import { formatCompactCount } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { normalizeRating } from './product-info-rating'

interface ProductInfoRatingSummaryProps {
  rating: {
    avg: number
    count: number
  }
  soldProduct?: number
}

const MAX_RATING = 5

// Dòng tóm tắt dưới tên sản phẩm: ★ 4.5/5 (99 đánh giá) | 15K+ đã bán
export const ProductInfoRatingSummary = ({
  rating,
  soldProduct = 0,
}: ProductInfoRatingSummaryProps) => {
  const t = useTranslations('product_detail.title')
  const hasRating = rating.avg > 0 && rating.count > 0
  const hasSold = soldProduct > 0

  if (!hasRating && !hasSold) return null

  const scrollToReviews = () => {
    document
      .getElementById('product-reviews')
      ?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className='flex min-w-0 items-center gap-1.5 whitespace-nowrap font-sans text-sm tracking-[0.03em] lg:gap-6'>
      {hasRating && (
        <button
          type='button'
          className='flex items-center gap-1 lg:gap-2'
          onClick={scrollToReviews}
        >
          <span className='flex items-center gap-1 text-neutral-600'>
            <Image
              src='/icons/icon-star.svg'
              width={20}
              height={20}
              alt='star'
            />
            {normalizeRating(rating.avg, MAX_RATING)}/{MAX_RATING}
          </span>
          <span className='text-neutral-500'>
            ({' '}
            <span className='underline'>
              {t('review_count', { count: rating.count })}
            </span>
            )
          </span>
        </button>
      )}
      {hasRating && hasSold && (
        <span className='h-[19px] w-px bg-neutral-200' aria-hidden />
      )}
      {hasSold && (
        <span className='text-neutral-500'>
          {t('sold_count', { count: formatCompactCount(soldProduct) })}
        </span>
      )}
    </div>
  )
}
